import React from 'react';
import { Layer, Source } from "react-map-gl";

const layout = {
    "line-join": "round",
    "line-cap": "round",
};

const black = {
    "line-color": "black",
    "line-width": 1,
    "line-opacity": 1,
};

const paint = {
    "line-color": ["get", "color"],
    "line-width": 5,
    "line-opacity": ["get", "opacity"],
    //"line-opacity": 1,
};

function CourseMap(props) {
  const { courseGeojson } = props;

  if (!courseGeojson || !courseGeojson.features) return;


  // Pointタイプのフィーチャを抽出するためのフィルタ
  const pointFilter = ["==", ["geometry-type"], "Point"];

  return (
    <Source type="geojson" data={courseGeojson}>
      {/* ドット線以外の表示 */}
     <Layer
        id="solid-course"
        type="line"
        source="data"
        layout={layout}
        paint={paint}
      />
      <Layer
        id="center-course"
        type="line"
        source="data"
        layout={layout}
        paint={black}
      />
 
    </Source>
  );
}

export default React.memo(CourseMap);
